import { addMinutes } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { OfferedSlot } from '../../types/appointments';

export const MAX_OFFERED_SLOTS = 3;

/**
 * An elapsed offer is already off the client's link, so it can neither be
 * re-sent nor re-offered. One split for everything that has to know.
 */
export function splitOfferedSlots(offeredSlots: OfferedSlot[] | undefined) {
  const now = Date.now();
  const starts = (offeredSlots ?? []).map(slot => slot.startDateTime);

  return {
    live: starts.filter(start => new Date(start).getTime() > now),
    elapsed: starts.filter(start => new Date(start).getTime() <= now).length,
  };
}

// Ascending order, capped — the payload is just ISO start times
export function toggleOfferedSlot(starts: string[], start: string) {
  const time = new Date(start).getTime();
  const existing = starts.find(value => new Date(value).getTime() === time);

  if (existing) {
    return starts.filter(value => value !== existing);
  }
  if (starts.length >= MAX_OFFERED_SLOTS) {
    return starts;
  }

  return [...starts, new Date(start).toISOString()].sort(
    (a, b) => new Date(a).getTime() - new Date(b).getTime(),
  );
}

export function isOfferedSlotSelected(starts: string[], start: string) {
  const time = new Date(start).getTime();
  return starts.some(value => new Date(value).getTime() === time);
}

export function formatOfferedSlotChip(
  start: string,
  lengthInMinutes: string | number | undefined,
  timezone: string,
) {
  const startDate = new Date(start);
  const length = Number(lengthInMinutes) || 0;
  const startText = formatInTimeZone(startDate, timezone, 'EEE MMM d, h:mma');

  if (!length) return startText;

  const endText = formatInTimeZone(
    addMinutes(startDate, length),
    timezone,
    'h:mma',
  );
  return `${startText} - ${endText}`;
}
